module.exports = __webpack_public_path__ + "img/img-widget-user.27c70cfe.svg";